import Vue from "vue";
import Modal from "./index.vue";
import store from "@/store"
import i18n from "@/utils/vue-i18n"

Modal.install = function(vm) {
  vm.component(Modal.name, Modal);
};
const div = document.createElement("div");
const instance = (close,component) => {
  console.log('component',component)
  const ModalConstructor = Vue.extend({
    render() {
      return <Modal vOn:close={close}>{component}</Modal>;
    },
    store,
    i18n
  });
  return new ModalConstructor();
};
Modal.show = function(options = {}) {
  if (typeof options !== "object") return "options error!";
  if (this.instance) {
    this.close();
  }
  this.instance = instance(this.close, options.component);
  document.body.appendChild(div);
  this.instance.$mount(div);
  return this.instance
};

Modal.close = function() {
  Modal.instance.$el.parentNode.removeChild(Modal.instance.$el);
  Modal.instance = null;
};
export default Modal;
